import React from 'react';
import { Provider } from 'react-redux';

import store from '../store';

import AppRoot from './components/AppRoot';
import startupConfiguration from './startupConfiguration';
import { useGlobalStyles } from './stylesheets/globalStyles';

startupConfiguration();

const App = (): React.JSX.Element => {
  useGlobalStyles();

  document.oncontextmenu = (event: any) => {
    const isControl = ['INPUT', 'A', 'TEXTAREA'].includes(event.target.tagName);

    if (!isControl || !event.target.contentEditable) {
      return false;
    }
  };

  return (
    <Provider store={store}>
      <AppRoot />
    </Provider>
  );
};

export default App;
